import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Link,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import ResetPassword from "./RessetPassword";
import CustomTextField from "./CustomTextField";

const errorTextStyle = {
  backgroundColor: "#00000075",
  color: "red",
  padding: "5px",
  borderRadius: "5px",
};

const ForgetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [showConfPass, setShowConfPass] = useState(false);
  const { login } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [codeStep, setCodeStep] = useState(false);

  const handleClickShowPassword = () => setShowPass((show) => !show);
  const handleClickShowConfPassword = () => setShowConfPass((show) => !show);
  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const handleMouseDownConfPassword = (e) => {
    e.preventDefault();
  };

  const registerForm = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter valid email")
        .required("Email is required"),
    }),
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: async (values, action) => {
      try {
        setLoading(true);

        // const data = await loginUser(values);
        // if (!data?.token) {
        //   "";
        //   toast.error(data.message);
        //   return;
        // }
        // setUser(data);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL_USER}/forgotPassword`,
          {
            email: values.email,
          }
        );

        if (response?.data?.success) {
          toast.success(response?.data?.message);
          setEmail(values.email);
          setCodeStep(true);
          // navigate("/resetpassword");
        } else {
          toast.error(response?.data?.message);
        }
      } catch (error) {
        if (error?.response) {
          toast.error(error?.response?.data?.message);
        } else {
          toast.error(error.message);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
        // onClick={}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="RegisterDiv">
        <Box
          className="skip_option"
          sx={{ justifyContent: "start !important" }}
        >
          <Box className="skip">
            <Button
              onClick={() => {
                if (codeStep) {
                  setCodeStep(false);
                } else {
                  navigate(-1);
                }
              }}
            >
              <ArrowBackIosIcon className="ficon" />
              Back
            </Button>
          </Box>
        </Box>

        {codeStep ? (
          <ResetPassword email={email} />
        ) : (
          <Box className="form_wrapper">
            <Box className="form_inner">
              <Typography component="h2" className="form_head">
                Forgot password?
              </Typography>
              <Typography component="p" className="form_sub_head">
                Enter your email for verification process, we will send <br /> 4
                digit code to your email.
              </Typography>
              <form onSubmit={registerForm.handleSubmit}>
                <Box className="form">
                  <CustomTextField
                    id="outlined-basic"
                    // label="Outlined"
                    name="email"
                    variant="outlined"
                    className="register_field"
                    placeholder="Email"
                    value={registerForm.values.email}
                    onChange={registerForm.handleChange}
                    error={
                      registerForm.touched.email &&
                      Boolean(registerForm.errors.email)
                    }
                    helperText={
                      registerForm.touched.email &&
                      Boolean(registerForm.errors.email) && (
                        <span style={errorTextStyle}>
                          {registerForm.errors.email}
                        </span>
                      )
                    }
                    autoComplete="off"
                  />

                  <Button className="Register" type="submit">
                    Submit
                  </Button>
                </Box>
              </form>
              <Box className="add-navi">
                <Typography component="p">
                  Back to <Link onClick={() => navigate("/login")}>Login</Link>
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default ForgetPassword;
